import api from './api.js'

/*
 * Download a binary endpoint (PDF / UBL) as a file. The API returns a blob;
 * we infer the filename from Content-Disposition when present, else fall back.
 */
export async function downloadBlob(path, fallbackName) {
  const res = await api.get(path, { responseType: 'blob' })
  const disposition = res.headers?.['content-disposition'] || ''
  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition)
  const name = match ? decodeURIComponent(match[1]) : fallbackName
  const url = URL.createObjectURL(res.data)
  const a = document.createElement('a')
  a.href = url
  a.download = name
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}
